<template>
  <div class="nav-bar">
    <div :class="{'center':type=='center'}">
      <div class="nav-left">
        <a :href="baseUrl" target="_blank">
          <img src="~assets/logo.png" />
        </a>
      </div>
      <div class="nav-right">
        <el-dropdown placement="bottom-start" :hide-on-click="false">
          <div class="workorder">
            <svg class="icon">
              <use xlink:href="#icon-gongdan" />
            </svg>
            工单
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu class="dropdown-menu-wrapper" slot="dropdown">
            <el-dropdown-item>
              <router-link to="/workorder/myworkorder">
                <svg class="icon">
                  <use xlink:href="#icon-workorder" />
                </svg>
                我的工单
              </router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/workorder/commit">
                <svg class="icon">
                  <use xlink:href="#icon-tijiao" />
                </svg>
                提交工单
              </router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown :hide-on-click="false">
          <div class="finance">
            <svg class="icon">
              <use xlink:href="#icon-caiwu" />
            </svg>
            财务
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu
            class="dropdown-menu-wrapper balance-menu"
            style="min-width:2.2rem;"
            slot="dropdown"
          >
            <el-dropdown-item>
              <div class="balance">
                <p>
                  <span>
                    <svg class="icon">
                      <use xlink:href="#icon-dollor" />
                    </svg>
                    余额
                  </span>
                  <router-link to="/center/charge">
                    <el-button size="mini">立即充值</el-button>
                  </router-link>
                </p>
                <p class="balance-val">¥{{$store.state.balance.formatBalance}}</p>
              </div>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <router-link to="/center/account">
                <svg class="icon">
                  <use xlink:href="#icon-caiwu" />
                </svg>
                账户
              </router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/center/order">
                <svg class="icon">
                  <use xlink:href="#icon-order" />
                </svg>
                订单管理
              </router-link>
            </el-dropdown-item>
            <!-- <el-dropdown-item>
              <router-link to="/center/contract">
                <svg class="icon">
                  <use xlink:href="#icon-contract" />
                </svg>
                合同管理
              </router-link>
            </el-dropdown-item> -->
            <el-dropdown-item>
              <router-link to="/center/invoice">
                <svg class="icon">
                  <use xlink:href="#icon-fapiaoguanli" />
                </svg>
                发票管理
              </router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown placement="bottom" :hide-on-click="false">
          <div class="username">
            <span>{{$store.state.auth.nickname||$store.state.auth.email}}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu class="dropdown-menu-wrapper" style="min-width:2rem" slot="dropdown">
            <el-dropdown-item>
              <div class="email" :title="$store.state.auth.email">
                <p>{{$store.state.auth.email}}</p>
                <div class="certi-area">
                  <div
                    :class="'certi-every certi-'+typeClass"
                    @click="goLink('/user/authentication')"
                  >
                    <div :class="'icon-cert '+typeClass+'-icon'"></div>
                    <span>{{$store.state.auth.certificateDesc}}</span>
                  </div>
                </div>
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/app/myapp">
                <svg class="icon">
                  <use xlink:href="#icon-appmanage" />
                </svg>
                我的应用
              </router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/user/baseinfo">
                <svg class="icon">
                  <use xlink:href="#icon-user" />
                </svg>
                基本资料
              </router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/user/security">
                <svg class="icon">
                  <use xlink:href="#icon-anquan" />
                </svg>
                安全设置
              </router-link>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <div class="logout">
                <router-link to="/logout">
                  <svg class="icon">
                    <use xlink:href="#icon-logout" />
                  </svg>
                  退出登录
                </router-link>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ajax from 'api/userauth'
import accountAjax from 'api/account'

export default {
  name: 'NavBar',
  props: ['type'],
  data() {
    return {
      isCertificate: false,
      typeClass: 'uncerti',
    }
  },
  computed: {
    msgCount() {
      return Number(this.$store.state.message.count)
    },
    memberUrl() {
      return Url[Mode].memberUrl
    },
    baseUrl() {
      return Url[Mode].baseUrl
    },
    certificatedStatus() {
      return {
        certificated: this.$store.state.auth.isCertificated,
        auditing: this.$store.state.auth.certificateType == 5
      }
    }
  },
  mounted() {
    this.$store.dispatch('setUserInfo')
    this.$store.dispatch('setBalance')
    this.$store.dispatch('setCertificateInfo')
    this.$store.dispatch('setUnReadCount')
    this.$store.dispatch('setLevel')
    this.getTypeClass(this.$store.state.auth.certificateDesc)
  },
  methods: {
    ...mapActions([
      'beginLogin'
    ]),
    goLink(link) {
      window.open(link)
    },
    getTypeClass(certificateDesc) {
      let typeClass = 'uncerti'
      switch (certificateDesc) {
        case '个人认证': {
          typeClass = 'personal'
          break
        }
        case '学生认证': {
          typeClass = 'student'
          break
        }
        case '创业团队认证': {
          typeClass = 'business-team'
          break
        }
        case '企业认证': {
          typeClass = 'company'
          break
        }
        default: {
          typeClass = 'uncerti'
        }
      }
      this.typeClass = typeClass
    }
  },
  watch: {
    '$store.state.auth.loggedIn': function (n) {
      if (!n) {
        location.href = Url[Mode].baseUrl
      }
    },
    '$store.state.auth.certificateDesc': function (n, o) {
      this.getTypeClass(n)
    },
  }
}
</script>

<style lang="stylus">
@import '~styl/mixins';
@import '~styl/variables';

svg-icons();

.dropdown-menu-wrapper {
  margin: 0 !important;
  padding: 0 !important;
  color: color-light-black;
  background-color: color-white;
  border: 1px solid rgb(209, 220, 229);
  border-top: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);

  &.balance-menu .el-dropdown-menu__item {
    cursor: default;
  }

  .el-dropdown-menu__item {
    line-height: 0.28rem;
    padding: 0.08rem 0.2rem;

    a {
      display: inline-block;
      width: 100%;
      color: color-light-black;
    }

    .icon {
      top: 0.02rem;
    }
  }

  .el-dropdown-menu__item--divided {
    margin-top: 0;

    &::before {
      content: none;
    }
  }

  .email {
    a {
      width: auto;
      color: color-danger;

      &.certificated {
        color: color-success;
      }

      &.auditing {
        color: color-danger;
      }
    }
  }

  .certi-area {
    height: 50px;
    display: flex;
    justify-content: space-around;

    .certi-every {
      min-width: 50px;
      height: 50px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;

      span {
        font-size: 12px;
        line-height: 15px;
      }

      .icon-cert {
        width: 25px;
        text-align: center;
        background-size: contain;
        height: 25px;
        line-height: 18px;
        margin: 0 auto;
      }
    }

    .certi-company {
      .company-icon {
        background: url('~assets/company-icon.png') no-repeat center center;
        background-size: contain;
      }
    }

    .certi-business-team {
      .business-team-icon {
        background: url('~assets/business-team-icon.png') no-repeat center center;
        background-size: contain;
      }
    }

    .certi-personal {
      .personal-icon {
        background: url('~assets/personal-icon.png') no-repeat center center;
        background-size: contain;
      }
    }

    .certi-student {
      .student-icon {
        background: url('~assets/student-icon.png') no-repeat center center;
        background-size: contain;
      }
    }

    .certi-uncerti {
      .uncerti-icon {
        background: url('~assets/uncerti-icon.png') no-repeat center center;
        background-size: contain;
      }
    }
  }

  .icon-auth-user {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url('~assets/auth-icon.png') no-repeat;
    background-size: contain;
    margin-right: 0;
    vertical-align: text-top;
  }

  .certi-text-circle {
    display: inline-block;
    background: #13ce66;
    color: #fff;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    vertical-align: text-bottom;
  }

  .gray-vip {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
  }

  #kt-span {
    font-size: 12px;
    line-height: 18px;
    font-style: normal;
    vertical-align: text-bottom;
    display: inline-block;
    text-align: right;
    font-weight: bold;
    color: #333;
  }

  .balance {
    color: color-light-black !important;

    a {
      width: auto;
    }

    .el-button {
      position: absolute;
      right: 0.08rem;
      top: 0.08rem;
    }

    .balance-val {
      font-size: 0.2rem;
      font-weight: bold;
    }
  }

  .logout {
    text-align: center;

    &>a {
      display: inline-block;
      padding: 0.05rem 0;
    }
  }
}

.nav-bar {
  min-width: 9.1rem;
  height: 0.6rem;
  font-size: 0.14rem;
  background: color-nav;
  color: color-main;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;

  .nav-left {
    display: flex;
    align-items: center;
    padding-left .2rem
    .divie-line {
      width 0
      height 30px
      border-right 1px solid #40485a
      margin 0 10px
    }
    a {
      display inline-block
      width 320px
      height 100%
      display flex
      justify-content flex-start
      align-items center

      > img {
        max-width: 100%
        max-height 75%
      }
    }
  }

  .message, .workorder, .finance, .username {
    margin: 0 0.2rem 0 0.2rem;
    line-height: 0.6rem;
    cursor: pointer;

    .el-icon-arrow-down {
      font-size: 0.14rem;
      margin-left: 0.05rem;
    }

    a {
      color: #fff;
    }
  }

  .username {
    display: flex;
    align-items: center;
    margin: 0 0.4rem 0 0.5rem;
    position: relative;

    span {
      max-width: 1.6rem;
      font-size: 0.14rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0.15rem;
      bottom: 0.15rem;
      left: -0.3rem;
      width: 0.01rem;
      background-color: #40485a;
    }
  }

  & > div {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    width: 100%;
    height: 100%;
  }

  &.center {
    width: 13rem;
    margin: 0 auto;
  }

  .nav-right {
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;

    .el-dropdown, .message a {
      color: #fff;

      .el-icon-arrow-down:before {
        // content ""
      }

      &:hover {
        color: #20a0ff !important;
      }
    }

    .message a {
      display: inline-block;
      line-height: 0.6rem;
    }
  }

  .user-wrapper {
    color: #eee;
  }

  .user-wrapper {
    margin-right: 0.2rem;

    & > span, & > a {
      font-size: 0.14rem;
      margin: auto 0.1rem;
    }
  }

  .user-link {
    cursor: pointer;
  }

  .user-register {
    background-color: color-nav;
    border-color: color-dark-blue;
    color: color-dark-blue;

    &:hover {
      border-color: color-light-blue;
      color: color-light-blue;
    }
  }

  .badge {
    position: relative;
    bottom: 6px;
    left: -5px;
    background-color: #f56c6c;
    border-radius: 10px;
    color: #fff;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 5px;
    text-align: center;
    white-space: nowrap;
  }

  .icon {
    display: inline-block;
    width: 0.18rem;
    height: 0.18rem;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    position: relative;
    top: 0.04rem;
  }
}

@keyframes dropdown-ani {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// app/components/NavBar/Main.vue